export default {
    en: {
        creatures: {
            title: "Tavern of Azoth - Creatures",
            description: "List of all creatures",
            metaDescription: "Generate magnificent and fearsome beasts from a simple description. Make them contextual to your campaign and balanced to any challenge rating you want.",
            actionPanel: "Let your imagination free by using the <b class='text-white'>text-to-creature</b> service to generate unique encounters for your campaigns.",
            equipmentTitle: "Equipment",
            addEquipment: "Add Equipment",
            beginHere: "Begin here...",
            waitTime: "Wait {time}s",
            generateCreature: "Generate Creature",
            recentCreatures: "Your Recent Creatures",
            sections: {
                description: "Description",
                behavior: "Behavior",
                actions: "Actions",
                legendaryActions: "Legendary Actions",
                reactions: "Reactions",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'User ID',
            edition: 'Edition',
            name: 'Name',
            race: 'Race',
            class: 'Class',
            alignment: 'Alignment',
            size: 'Size',
            level: 'Level',
            armor_class: 'Armor Class',
            hit_points: 'Hit Points',
            str: 'Str',
            dex: 'Dex',
            con: 'Con',
            int: 'Int',
            wis: 'Wis',
            cha: 'Cha',
            saving_throws: 'Saving Throws',
            damage_resistances: 'Damage Resistances',
            damage_immunities: 'Damage Immunities',
            condition_immunities: 'Condition Immunities',
            senses: 'Senses',
            languages: 'Languages',
            challenge_rating: 'Challenge Rating',
            actions: 'Actions',
            legendary_actions: 'Legendary Actions',
            reactions: 'Reactions',
            initiative: 'Initiative',
            immune: 'Immunities',
            resist: 'Resistances',
            vulnerable: 'Vulnerabilities',
            action_points: 'Action Points',
            speed: 'Speed',
            skills: 'Skills',
            environment: 'Environment',
            organization: 'Organization',
            treasure: 'Treasure',
            description: 'Description',
            favorites_count: 'Favorites Count',
            image_description: 'Image Description',
            image_regenerations: 'Image Regenerations',
            equipment_description: 'Equipment Description',
            illustrations: 'Illustrations',
            metadata: 'Metadata',
            stash_id: 'Stash ID',
            hit_dice: 'Hit Dice',
            move: 'Move',
            number_of_attacks: 'Number of Attacks',
            damage_attacks: 'Damage Attacks',
            number_appearing: 'Number Appearing',
            percent_in_lair: 'Percent in Lair',
            intelligence: 'Intelligence',
            automatic_abilities: 'Automatic Abilities',
            reactive_abilities: 'Reactive Abilities',
            perception: 'Perception',
            melee: 'Melee',
            base_attack_bonus: 'Base Attack Bonus',
            combat_maneuver_bonus: 'Combat Maneuver Bonus',
            combat_maneuver_defense: 'Combat Maneuver Defense',
            feats: 'Feats',
            special_qualities: 'Special Qualities',
            space: 'Space',
            reach: 'Reach',
            special_attacks: 'Special Attacks',
            fortitude: 'Fortitude',
            reflex: 'Reflex',
            will: 'Will',
            experience: 'Experience',
            ranged: 'Ranged',
            spell_like_abilities: 'Spell-Like Abilities',
            spells_known: 'Spells Known',
            spells: 'Spells',
            abilities: 'Abilities',
            racial_modifiers: 'Racial Modifiers',
        }
    },
    fr: {
        creatures: {
            title: "Tavern of Azoth - Créatures",
            description: "Liste de toutes les créatures",
            actionPanel: "Libérez votre imagination en utilisant le service <b class='text-white'>texte-à-créature</b> pour générer des rencontres uniques pour vos campagnes.",
            equipmentTitle: "Équipement",
            addEquipment: "Ajouter de l'Équipement",
            beginHere: "Commencez ici...",
            waitTime: "Attendez {{ time }}s",
            generateCreature: "Générer une Créature",
            recentCreatures: "Vos Créatures Récents",
            sections: {
                description: "Description",
                behavior: "Comportement",
                actions: "Actions",
                legendaryActions: "Actions Légendaires",
                reactions: "Réactions",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'ID Utilisateur',
            edition: 'Édition',
            name: 'Nom',
            race: 'Race',
            class: 'Classe',
            alignment: 'Alignement',
            size: 'Taille',
            armor_class: 'Classe d\'Armure',
            hit_points: 'Points de Vie',
            speed: 'Vitesse',
            str: 'For',
            dex: 'Dex',
            con: 'Con',
            int: 'Int',
            wis: 'Sag',
            cha: 'Cha',
            saving_throws: 'Jets de Sauvegarde',
            damage_resistances: 'Résistances aux Dégâts',
            damage_immunities: 'Immunités aux Dégâts',
            condition_immunities: 'Immunités aux États',
            senses: 'Sens',
            languages: 'Langues',
            challenge_rating: 'Niveau de Défi',
            actions: 'Actions',
            legendary_actions: 'Actions Légendaires',
            reactions: 'Réactions',
            description: 'Description',
            favorites_count: 'Nombre de Favoris',
            image_description: 'Description de l\'Image',
            image_regenerations: 'Régénérations d\'Image',
            equipment_description: 'Description de l\'Équipement',
            illustrations: 'Illustrations',
            metadata: 'Métadonnées',
            stash_id: 'ID de Cache',
            level: 'Niveau',
            initiative: 'Initiative',
            immune: 'Immunités',
            resist: 'Résistances',
            vulnerable: 'Vulnérabilités',
            action_points: 'Points d\'Action',
            environment: 'Environnement',
            organization: 'Organisation',
            treasure: 'Trésor',
            skills: 'Compétences',
            hit_dice: 'Dé de Vie',
            move: 'Mouvement',
            number_of_attacks: 'Nombre d’Attaques',
            damage_attacks: 'Dégâts des Attaques',
            number_appearing: 'Nombre Apparaissant',
            percent_in_lair: 'Pourcentage dans le Repaire',
            intelligence: 'Intelligence',
            automatic_abilities: 'Capacités Automatiques',
            reactive_abilities: 'Capacités Réactives',
            perception: 'Perception',
            melee: 'Mêlée',
            base_attack_bonus: 'Bonus de Base à l’Attaque',
            combat_maneuver_bonus: 'Bonus de Manœuvre de Combat',
            combat_maneuver_defense: 'Défense de Manœuvre de Combat',
            feats: 'Dons',
            special_qualities: 'Qualités Spéciales',
            space: 'Espace',
            reach: 'Allonge',
            special_attacks: 'Attaques Spéciales',
            fortitude: 'Vigueur',
            reflex: 'Réflexes',
            will: 'Volonté',
            experience: 'Expérience',
            ranged: 'À distance',
            spell_like_abilities: 'Capacités similaires à des sorts',
            spells_known: 'Sorts connus',
            spells: 'Sorts',
            abilities: 'Capacités',
            racial_modifiers: 'Modificateurs raciaux',
        }
    },
    es: {
        creatures: {
            title: "Tavern of Azoth - Criaturas",
            description: "Lista de todas las criaturas",
            metaDescription: "Genera bestias magníficas y temibles a partir de una simple descripción. Adáptalas a tu campaña y equilíbralas para cualquier nivel de desafío que desees.",
            actionPanel: "Libera tu imaginación utilizando el servicio <b class='text-white'>texto-a-criatura</b> para generar encuentros únicos para tus campañas.",
            equipmentTitle: "Equipo",
            addEquipment: "Agregar Equipo",
            beginHere: "Comienza aquí...",
            waitTime: "Espera {time}s",
            generateCreature: "Generar Criatura",
            recentCreatures: "Tus Criaturas Recientes",
            sections: {
                description: "Descripción",
                behavior: "Comportamiento",
                actions: "Acciones",
                legendaryActions: "Acciones Legendarias",
                reactions: "Reacciones",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'ID de Usuario',
            edition: 'Edición',
            name: 'Nombre',
            race: 'Raza',
            class: 'Clase',
            alignment: 'Alineamiento',
            size: 'Tamaño',
            armor_class: 'Clase de Armadura',
            hit_points: 'Puntos de Golpe',
            str: 'Fue',
            dex: 'Des',
            con: 'Con',
            int: 'Int',
            wis: 'Sab',
            cha: 'Car',
            saving_throws: 'Tiradas de Salvación',
            damage_resistances: 'Resistencias al Daño',
            damage_immunities: 'Inmunidades al Daño',
            condition_immunities: 'Inmunidades a Condiciones',
            senses: 'Sentidos',
            languages: 'Idiomas',
            challenge_rating: 'Nivel de Desafío',
            actions: 'Acciones',
            legendary_actions: 'Acciones Legendarias',
            reactions: 'Reacciones',
            description: 'Descripción',
            favorites_count: 'Conteo de Favoritos',
            image_description: 'Descripción de la Imagen',
            image_regenerations: 'Regeneraciones de Imagen',
            equipment_description: 'Descripción del Equipo',
            illustrations: 'Ilustraciones',
            metadata: 'Metadatos',
            stash_id: 'ID del Almacén',
            level: 'Nivel',
            initiative: 'Iniciativa',
            immune: 'Inmunidades',
            resist: 'Resistencias',
            vulnerable: 'Vulnerabilidades',
            action_points: 'Puntos de Acción',
            environment: 'Entorno',
            organization: 'Organización',
            treasure: 'Tesoro',
            skills: 'Habilidades',
            speed: 'Velocidad',
            hit_dice: 'Dados de Golpe',
            move: 'Movimiento',
            number_of_attacks: 'Número de Ataques',
            damage_attacks: 'Daño de Ataques',
            number_appearing: 'Número Apareciendo',
            percent_in_lair: 'Porcentaje en la Guarida',
            intelligence: 'Inteligencia',
            automatic_abilities: 'Habilidades Automáticas',
            reactive_abilities: 'Habilidades Reactivas',
            perception: 'Percepción',
            melee: 'Cuerpo a Cuerpo',
            base_attack_bonus: 'Bonificación Base de Ataque',
            combat_maneuver_bonus: 'Bonificación de Maniobra de Combate',
            combat_maneuver_defense: 'Defensa de Maniobra de Combate',
            feats: 'Dotes',
            special_qualities: 'Cualidades Especiales',
            space: 'Espacio',
            reach: 'Alcance',
            special_attacks: 'Ataques Especiales',
            fortitude: 'Fortaleza',
            reflex: 'Reflejos',
            will: 'Voluntad',
            experience: 'Experiencia',
            ranged: 'A distancia',
            spell_like_abilities: 'Habilidades similares a conjuros',
            spells_known: 'Conjuros conocidos',
            spells: 'Conjuros',
            abilities: 'Habilidades',
            racial_modifiers: 'Modificadores raciales',
        }
    },
    de: {
        creatures: {
            title: "Tavern of Azoth - Kreaturen",
            description: "Liste aller Kreaturen",
            metaDescription: "Erstelle prächtige und furchterregende Bestien aus einer einfachen Beschreibung. Passe sie an deine Kampagne an und balanciere sie für jede Herausforderungsstufe, die du möchtest.",
            actionPanel: "Lassen Sie Ihrer Fantasie freien Lauf, indem Sie den <b class='text-white'>Text-zu-Kreatur</b> Dienst nutzen, um einzigartige Begegnungen für Ihre Kampagnen zu erzeugen.",
            equipmentTitle: "Ausrüstung",
            addEquipment: "Ausrüstung hinzufügen",
            beginHere: "Hier beginnen...",
            waitTime: "Warte {time}s",
            generateCreature: "Kreatur generieren",
            recentCreatures: "Deine neuesten Kreaturen",
            sections: {
                description: "Beschreibung",
                behavior: "Verhalten",
                actions: "Aktionen",
                legendaryActions: "Legendäre Aktionen",
                reactions: "Reaktionen",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'Benutzer-ID',
            edition: 'Ausgabe',
            name: 'Name',
            race: 'Rasse',
            class: 'Klasse',
            alignment: 'Ausrichtung',
            size: 'Größe',
            armor_class: 'Rüstungsklasse',
            hit_points: 'Trefferpunkte',
            str: 'Str',
            dex: 'Gew',
            con: 'Kon',
            int: 'Int',
            wis: 'Wei',
            cha: 'Cha',
            saving_throws: 'Rettungswürfe',
            damage_resistances: 'Schadensresistenzen',
            damage_immunities: 'Schadensimmunitäten',
            condition_immunities: 'Zustandsimmunitäten',
            senses: 'Sinne',
            languages: 'Sprachen',
            challenge_rating: 'Herausforderungsstufe',
            actions: 'Aktionen',
            legendary_actions: 'Legendäre Aktionen',
            reactions: 'Reaktionen',
            description: 'Beschreibung',
            favorites_count: 'Anzahl der Favoriten',
            image_description: 'Bildbeschreibung',
            image_regenerations: 'Bildregenerationen',
            equipment_description: 'Ausrüstungsbeschreibung',
            illustrations: 'Illustrationen',
            metadata: 'Metadaten',
            stash_id: 'Lager-ID',
            level: 'Stufe',
            initiative: 'Initiative',
            immune: 'Immunitäten',
            resist: 'Resistenzen',
            vulnerable: 'Verwundbarkeiten',
            action_points: 'Aktionspunkte',
            environment: 'Umgebung',
            organization: 'Organisation',
            treasure: 'Schatz',
            skills: 'Fertigkeiten',
            speed: 'Geschwindigkeit',
            hit_dice: 'Trefferwürfel',
            move: 'Bewegung',
            number_of_attacks: 'Anzahl der Angriffe',
            damage_attacks: 'Schadensangriffe',
            number_appearing: 'Anzahl Erscheinender',
            percent_in_lair: 'Prozent im Versteck',
            intelligence: 'Intelligenz',
            automatic_abilities: 'Automatische Fähigkeiten',
            reactive_abilities: 'Reaktive Fähigkeiten',
            perception: 'Wahrnehmung',
            melee: 'Nahkampf',
            base_attack_bonus: 'Grundangriffsbonus',
            combat_maneuver_bonus: 'Kampfmanöver-Bonus',
            combat_maneuver_defense: 'Kampfmanöver-Verteidigung',
            feats: 'Talente',
            special_qualities: 'Besondere Eigenschaften',
            space: 'Raum',
            reach: 'Reichweite',
            special_attacks: 'Besondere Angriffe',
            fortitude: 'Zähigkeit',
            reflex: 'Reflexe',
            will: 'Willenskraft',
            experience: 'Erfahrung',
            ranged: 'Fernkampf',
            spell_like_abilities: 'Zauberähnliche Fähigkeiten',
            spells_known: 'Bekannte Zauber',
            spells: 'Zauber',
            abilities: 'Fähigkeiten',
            racial_modifiers: 'Rassische Modifikatoren',
        }
    },
    pt: {
        creatures: {
            title: "Tavern of Azoth - Criaturas",
            description: "Lista de todas as criaturas",
            metaDescription: "Gere bestas magníficas e temíveis a partir de uma simples descrição. Adapte-as à sua campanha e equilibre-as para qualquer nível de desafio que desejar.",
            actionPanel: "Liberte sua imaginação usando o serviço <b class='text-white'>texto-para-criatura</b> para gerar encontros únicos para suas campanhas.",
            equipmentTitle: "Equipamento",
            addEquipment: "Adicionar Equipamento",
            beginHere: "Comece aqui...",
            waitTime: "Aguarde {time}s",
            generateCreature: "Gerar Criatura",
            recentCreatures: "Suas Criaturas Recentes",
            sections: {
                description: "Descrição",
                behavior: "Comportamento",
                actions: "Ações",
                legendaryActions: "Ações Lendárias",
                reactions: "Reações",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'ID do Usuário',
            edition: 'Edição',
            name: 'Nome',
            race: 'Raça',
            class: 'Classe',
            alignment: 'Alinhamento',
            size: 'Tamanho',
            armor_class: 'Classe de Armadura',
            hit_points: 'Pontos de Vida',
            str: 'For',
            dex: 'Des',
            con: 'Con',
            int: 'Int',
            wis: 'Sab',
            cha: 'Car',
            saving_throws: 'Testes de Resistência',
            damage_resistances: 'Resistência a Danos',
            damage_immunities: 'Imunidade a Danos',
            condition_immunities: 'Imunidade a Condições',
            senses: 'Sentidos',
            languages: 'Línguas',
            challenge_rating: 'Nível de Desafio',
            actions: 'Ações',
            legendary_actions: 'Ações Lendárias',
            reactions: 'Reações',
            description: 'Descrição',
            favorites_count: 'Contagem de Favoritos',
            image_description: 'Descrição da Imagem',
            image_regenerations: 'Regenerações de Imagem',
            equipment_description: 'Descrição do Equipamento',
            illustrations: 'Ilustrações',
            metadata: 'Metadados',
            stash_id: 'ID do Esconderijo',
            level: 'Nível',
            initiative: 'Iniciativa',
            immune: 'Imunidades',
            resist: 'Resistências',
            vulnerable: 'Vulnerabilidades',
            action_points: 'Pontos de Ação',
            environment: 'Ambiente',
            organization: 'Organização',
            treasure: 'Tesouro',
            skills: 'Habilidades',
            speed: 'Velocidade',
            hit_dice: 'Dados de Vida',
            move: 'Movimento',
            number_of_attacks: 'Número de Ataques',
            damage_attacks: 'Dano dos Ataques',
            number_appearing: 'Número Aparecendo',
            percent_in_lair: 'Percentual na Toca',
            intelligence: 'Inteligência',
            automatic_abilities: 'Habilidades Automáticas',
            reactive_abilities: 'Habilidades Reativas',
            perception: 'Percepção',
            melee: 'Corpo a Corpo',
            base_attack_bonus: 'Bônus Base de Ataque',
            combat_maneuver_bonus: 'Bônus de Manobra de Combate',
            combat_maneuver_defense: 'Defesa de Manobra de Combate',
            feats: 'Proezas',
            special_qualities: 'Qualidades Especiais',
            space: 'Espaço',
            reach: 'Alcance',
            special_attacks: 'Ataques Especiais',
            fortitude: 'Fortitude',
            reflex: 'Reflexos',
            will: 'Vontade',
            experience: 'Experiência',
            ranged: 'À distância',
            spell_like_abilities: 'Habilidades semelhantes a magias',
            spells_known: 'Magias conhecidas',
            spells: 'Magias',
            abilities: 'Habilidades',
            racial_modifiers: 'Modificadores raciais',
        }
    },
    it: {
        creatures: {
            title: "Taverna di Azoth - Creature",
            description: "Elenco di tutte le creature",
            metaDescription: "Genera creature magnifiche e temibili da una semplice descrizione. Rendile contestuali alla tua campagna e bilancia per qualsiasi livello di sfida tu desideri.",
            actionPanel: "Lascia libera la tua immaginazione utilizzando il servizio <b class='text-white'>testo-a-creatura</b> per generare incontri unici per le tue campagne.",
            equipmentTitle: "Equipaggiamento",
            addEquipment: "Aggiungi Equipaggiamento",
            beginHere: "Comincia qui...",
            waitTime: "Aspetta {time}s",
            generateCreature: "Genera Creatura",
            recentCreatures: "Le tue Creature Recenti",
            sections: {
                description: "Descrizione",
                behavior: "Comportamento",
                actions: "Azioni",
                legendaryActions: "Azioni Leggendarie",
                reactions: "Reazioni",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'ID Utente',
            edition: 'Edizione',
            name: 'Nome',
            race: 'Razza',
            class: 'Classe',
            alignment: 'Allineamento',
            size: 'Dimensione',
            armor_class: 'Classe Armatura',
            hit_points: 'Punti Ferita',
            str: 'For',
            dex: 'Des',
            con: 'Cos',
            int: 'Int',
            wis: 'Sag',
            cha: 'Car',
            saving_throws: 'Tiri Salvezza',
            damage_resistances: 'Resistenze ai Danni',
            damage_immunities: 'Immunità ai Danni',
            condition_immunities: 'Immunità alle Condizioni',
            senses: 'Sensi',
            languages: 'Lingue',
            challenge_rating: 'Livello di Sfida',
            actions: 'Azioni',
            legendary_actions: 'Azioni Leggendarie',
            reactions: 'Reazioni',
            description: 'Descrizione',
            favorites_count: 'Conteggio Preferiti',
            image_description: 'Descrizione Immagine',
            image_regenerations: 'Rigenerazioni Immagine',
            equipment_description: 'Descrizione Equipaggiamento',
            illustrations: 'Illustrazioni',
            metadata: 'Metadati',
            stash_id: 'ID Deposito',
            level: 'Livello',
            initiative: 'Iniziativa',
            immune: 'Immunizzazioni',
            resist: 'Resistenze',
            vulnerable: 'Vulnerabilità',
            action_points: 'Punti Azione',
            environment: 'Ambiente',
            organization: 'Organizzazione',
            treasure: 'Tesoro',
            skills: 'Abilità',
            speed: 'Velocità',
            hit_dice: 'Dadi di Colpo',
            move: 'Movimento',
            number_of_attacks: 'Numero di Attacchi',
            damage_attacks: 'Danni degli Attacchi',
            number_appearing: 'Numero Apparendo',
            percent_in_lair: 'Percentuale nella Tana',
            intelligence: 'Intelligenza',
            automatic_abilities: 'Abilità Automatiche',
            reactive_abilities: 'Abilità Reattive',
            perception: 'Percezione',
            melee: 'Mischia',
            base_attack_bonus: 'Bonus Base d’Attacco',
            combat_maneuver_bonus: 'Bonus di Manovra di Combattimento',
            combat_maneuver_defense: 'Difesa di Manovra di Combattimento',
            feats: 'Talenti',
            special_qualities: 'Qualità Speciali',
            space: 'Spazio',
            reach: 'Portata',
            special_attacks: 'Attacchi Speciali',
            fortitude: 'Costituzione',
            reflex: 'Riflessi',
            will: 'Volontà',
            experience: 'Esperienza',
            ranged: 'A distanza',
            spell_like_abilities: 'Abilità simili a incantesimi',
            spells_known: 'Incantesimi conosciuti',
            spells: 'Incantesimi',
            abilities: 'Abilità',
            racial_modifiers: 'Modificatori razziali',
        }
    },
    nl: {
        creatures: {
            title: "Taverne van Azoth - Wezens",
            description: "Lijst van alle wezens",
            metaDescription: "Genereer prachtige en angstaanjagende wezens vanuit een eenvoudige beschrijving. Maak ze contextueel voor jouw campagne en evenwichtig voor elke uitdaging die je wilt.",
            actionPanel: "Laat je fantasie de vrije loop door de <b class='text-white'>tekst-naar-wezen</b> service te gebruiken om unieke ontmoetingen te genereren voor je campagnes.",
            equipmentTitle: "Uitrusting",
            addEquipment: "Voeg Uitrusting Toe",
            beginHere: "Begin hier...",
            waitTime: "Wacht {time}s",
            generateCreature: "Genereer Wezen",
            recentCreatures: "Jouw Recentste Wezens",
            sections: {
                description: "Beschrijving",
                behavior: "Gedrag",
                actions: "Acties",
                legendaryActions: "Legendarische Acties",
                reactions: "Reacties",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'Gebruikers-ID',
            edition: 'Editie',
            name: 'Naam',
            race: 'Ras',
            class: 'Klasse',
            alignment: 'Uitlijning',
            size: 'Grootte',
            armor_class: 'Pantserklasse',
            hit_points: 'Levenspunten',
            str: 'Str',
            dex: 'Dex',
            con: 'Con',
            int: 'Int',
            wis: 'Wis',
            cha: 'Cha',
            saving_throws: 'Reddingsworpen',
            damage_resistances: 'Schade Weerstand',
            damage_immunities: 'Schade Immuniteit',
            condition_immunities: 'Voorwaarde Immuniteit',
            senses: 'Zintuigen',
            languages: 'Talen',
            challenge_rating: 'Uitdaging Rating',
            actions: 'Acties',
            legendary_actions: 'Legendarische Acties',
            reactions: 'Reacties',
            description: 'Beschrijving',
            favorites_count: 'Favorieten Telling',
            image_description: 'Afbeelding Beschrijving',
            image_regenerations: 'Afbeelding Regeneraties',
            equipment_description: 'Uitrusting Beschrijving',
            illustrations: 'Illustraties',
            metadata: 'Metadata',
            stash_id: 'Opslag ID',
            level: 'Niveau',
            initiative: 'Initiatief',
            immune: 'Immuniteit',
            resist: 'Weerstand',
            vulnerable: 'Kwetsbaarheid',
            action_points: 'Actiepunten',
            environment: 'Omgeving',
            organization: 'Organisatie',
            treasure: 'Schat',
            skills: 'Vaardigheden',
            speed: 'Snelheid',
            hit_dice: 'Schadepunten Dobbelsteen',
            move: 'Beweging',
            number_of_attacks: 'Aantal Aanvallen',
            damage_attacks: 'Schade Aanvallen',
            number_appearing: 'Aantal Verschijningen',
            percent_in_lair: 'Percentage in Hol',
            intelligence: 'Intelligentie',
            automatic_abilities: 'Automatische Vaardigheden',
            reactive_abilities: 'Reactieve Vaardigheden',
            perception: 'Perceptie',
            melee: 'Lijf-aan-lijf',
            base_attack_bonus: 'Basis Aanvalsbonus',
            combat_maneuver_bonus: 'Manoeuvre van Combat Bonus',
            combat_maneuver_defense: 'Verdediging van Combat Manoeuvre',
            feats: 'Vaardigheden',
            special_qualities: 'Bijzondere Kwaliteiten',
            space: 'Ruimte',
            reach: 'Bereik',
            special_attacks: 'Speciale Aanvallen',
            fortitude: 'Vastberadenheid',
            reflex: 'Reflex',
            will: 'Wilskracht',
            experience: 'Ervaring',
            ranged: 'Op afstand',
            spell_like_abilities: 'Spreukachtige Vaardigheden',
            spells_known: 'Bekende Spreuken',
            spells: 'Spreuken',
            abilities: 'Vaardigheden',
            racial_modifiers: 'Rasspecifieke Modifiers',
        }
    },
    zh: {
        creatures: {
            title: "阿佐斯酒馆 - 生物",
            description: "所有生物的列表",
            metaDescription: "从简单的描述中生成壮观和可怕的生物。使它们适应您的战役，并为您想要的任何挑战等级保持平衡。",
            actionPanel: "通过使用<b class='text-white'>文本转生物</b>服务，释放您的想象力，为您的活动生成独特的遭遇。",
            equipmentTitle: "装备",
            addEquipment: "添加装备",
            beginHere: "从这里开始...",
            waitTime: "等待 {time}秒",
            generateCreature: "生成生物",
            recentCreatures: "您最近的生物",
            sections: {
                description: "描述",
                behavior: "行为",
                actions: "行动",
                legendaryActions: "传奇行动",
                reactions: "反应",
            },
        },
        keys: {
            id: 'ID',
            user_id: '用户ID',
            edition: '版本',
            name: '名称',
            race: '种族',
            class: '职业',
            alignment: '阵营',
            size: '大小',
            armor_class: '护甲等级',
            hit_points: '生命值',
            str: '力量',
            dex: '敏捷',
            con: '体质',
            int: '智力',
            wis: '感知',
            cha: '魅力',
            saving_throws: '豁免投掷',
            damage_resistances: '伤害抗性',
            damage_immunities: '伤害免疫',
            condition_immunities: '状态免疫',
            senses: '感知',
            languages: '语言',
            challenge_rating: '挑战评级',
            actions: '行动',
            legendary_actions: '传奇行动',
            reactions: '反应',
            description: '描述',
            favorites_count: '收藏计数',
            image_description: '图片描述',
            image_regenerations: '图片再生',
            equipment_description: '装备描述',
            illustrations: '插图',
            metadata: '元数据',
            stash_id: '存储ID',
            level: '等级',
            initiative: '先机',
            immune: '免疫',
            resist: '抗性',
            vulnerable: '脆弱',
            action_points: '行动点数',
            environment: '环境',
            organization: '组织',
            treasure: '宝藏',
            skills: '技能',
            speed: '速度',
            hit_dice: '伤害骰',
            move: '移动',
            number_of_attacks: '攻击次数',
            damage_attacks: '伤害攻击',
            number_appearing: '出现次数',
            percent_in_lair: '巢穴中的百分比',
            intelligence: '智力',
            automatic_abilities: '自动能力',
            reactive_abilities: '反应能力',
            perception: '感知',
            melee: '近战',
            base_attack_bonus: '基础攻击加成',
            combat_maneuver_bonus: '战斗策略加成',
            combat_maneuver_defense: '战斗策略防御',
            feats: '特技',
            special_qualities: '特殊品质',
            space: '空间',
            reach: '攻击范围',
            special_attacks: '特殊攻击',
            fortitude: '坚韧',
            reflex: '反射',
            will: '意志',
            experience: '经验',
            ranged: '远程',
            spell_like_abilities: '类法术能力',
            spells_known: '已知法术',
            spells: '法术',
            abilities: '能力',
            racial_modifiers: '种族修正',
        }
    },
    ja: {
        creatures: {
            title: "アゾスの酒場 - 生物",
            description: "すべての生物のリスト",
            metaDescription: "シンプルな説明から壮大で恐ろしい生物を生成します。あなたのキャンペーンに合わせて、望むチャレンジレートにバランスを取ります。",
            actionPanel: "<b class='text-white'>テキスト-トゥ-クリーチャー</b>サービスを使用して想像力を解き放ち、キャンペーンのためのユニークなエンカウンターを生成しましょう。",
            equipmentTitle: "装備",
            addEquipment: "装備を追加",
            beginHere: "ここから始める...",
            waitTime: "{time}秒待つ",
            generateCreature: "生物を生成",
            recentCreatures: "最近の生物",
            sections: {
                description: "説明",
                behavior: "振る舞い",
                actions: "行動",
                legendaryActions: "伝説の行動",
                reactions: "反応",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'ユーザーID',
            edition: 'エディション',
            name: '名前',
            race: '種族',
            class: 'クラス',
            alignment: '整列',
            size: 'サイズ',
            armor_class: '防具クラス',
            hit_points: 'ヒットポイント',
            str: '力',
            dex: '敏捷性',
            con: '体力',
            int: '知力',
            wis: '叡智',
            cha: '魅力',
            saving_throws: 'セービングスロー',
            damage_resistances: 'ダメージ抵抗',
            damage_immunities: 'ダメージ免疫',
            condition_immunities: 'コンディション免疫',
            senses: '感覚',
            languages: '言語',
            challenge_rating: 'チャレンジレーティング',
            actions: '行動',
            legendary_actions: '伝説の行動',
            reactions: '反応',
            description: '説明',
            favorites_count: 'お気に入りの数',
            image_description: '画像の説明',
            image_regenerations: '画像再生成',
            equipment_description: '装備の説明',
            illustrations: 'イラスト',
            metadata: 'メタデータ',
            stash_id: 'スタッシュID',
            level: 'レベル',
            initiative: '先制判定',
            immune: '免疫',
            resist: '耐性',
            vulnerable: '脆弱',
            action_points: '行動ポイント',
            environment: '環境',
            organization: '組織',
            treasure: '財宝',
            skills: 'スキル',
            speed: '速度',
            hit_dice: 'ヒットダイス',
            move: '移動',
            number_of_attacks: '攻撃回数',
            damage_attacks: 'ダメージ攻撃',
            number_appearing: '現れる数',
            percent_in_lair: '巣内の割合',
            intelligence: '知性',
            automatic_abilities: '自動能力',
            reactive_abilities: '反応能力',
            perception: '知覚',
            melee: '接近戦',
            base_attack_bonus: '基本攻撃ボーナス',
            combat_maneuver_bonus: '戦術操作ボーナス',
            combat_maneuver_defense: '戦術操作防御',
            feats: 'フィート',
            special_qualities: '特殊な資質',
            space: 'スペース',
            reach: 'リーチ',
            special_attacks: '特殊攻撃',
            fortitude: '耐久',
            reflex: '反射',
            will: '意志',
            experience: '経験',
            ranged: '遠隔',
            spell_like_abilities: '呪文のような能力',
            spells_known: '知っている呪文',
            spells: '呪文',
            abilities: '能力',
            racial_modifiers: '種族の修正',
        }
    },
    ru: {
        creatures: {
            title: "Таверна Азота - Существа",
            description: "Список всех существ",
            metaDescription: "Создавайте великолепных и страшных зверей из простого описания. Адаптируйте их к вашей кампании и устанавливайте любой уровень сложности.",
            actionPanel: "Освободите свое воображение, используя сервис <b class='text-white'>текст-в-существо</b>, чтобы создавать уникальные встречи для ваших кампаний.",
            equipmentTitle: "Оборудование",
            addEquipment: "Добавить оборудование",
            beginHere: "Начните здесь...",
            waitTime: "Подождите {time}с",
            generateCreature: "Создать существо",
            recentCreatures: "Ваши последние существа",
            sections: {
                description: "Описание",
                behavior: "Поведение",
                actions: "Действия",
                legendaryActions: "Легендарные действия",
                reactions: "Реакции",
            },
        },
        keys: {
            id: 'ID',
            user_id: 'ID пользователя',
            edition: 'Издание',
            name: 'Имя',
            race: 'Раса',
            class: 'Класс',
            alignment: 'Мировоззрение',
            size: 'Размер',
            armor_class: 'Класс доспехов',
            hit_points: 'Очки здоровья',
            str: 'Сила',
            dex: 'Ловкость',
            con: 'Телосложение',
            int: 'Интеллект',
            wis: 'Мудрость',
            cha: 'Харизма',
            saving_throws: 'Спасброски',
            damage_resistances: 'Сопротивление урону',
            damage_immunities: 'Иммунитет к урону',
            condition_immunities: 'Иммунитет к состояниям',
            senses: 'Чувства',
            languages: 'Языки',
            challenge_rating: 'Уровень вызова',
            actions: 'Действия',
            legendary_actions: 'Легендарные действия',
            reactions: 'Реакции',
            description: 'Описание',
            favorites_count: 'Количество избранных',
            image_description: 'Описание изображения',
            image_regenerations: 'Регенерации изображения',
            equipment_description: 'Описание оборудования',
            illustrations: 'Иллюстрации',
            metadata: 'Метаданные',
            stash_id: 'ID тайника',
            level: 'Уровень',
            initiative: 'Инициатива',
            immune: 'Иммунитет',
            resist: 'Сопротивляемость',
            vulnerable: 'Уязвимость',
            action_points: 'Очки действия',
            environment: 'Окружение',
            organization: 'Организация',
            treasure: 'Сокровище',
            skills: 'Навыки',
            speed: 'Скорость',
            hit_dice: 'Бросок Жизни',
            move: 'Движение',
            number_of_attacks: 'Количество Атак',
            damage_attacks: 'Урон от Атаки',
            number_appearing: 'Число Появлений',
            percent_in_lair: 'Процент в Логове',
            intelligence: 'Интеллект',
            automatic_abilities: 'Автоматические Способности',
            reactive_abilities: 'Реактивные Способности',
            perception: 'Восприятие',
            melee: 'Ближний Бой',
            base_attack_bonus: 'Базовый Бонус Атаки',
            combat_maneuver_bonus: 'Бонус Боевых Маневров',
            combat_maneuver_defense: 'Защита от Боевых Маневров',
            feats: 'Достижения',
            special_qualities: 'Особые Качества',
            space: 'Пространство',
            reach: 'Досягаемость',
            special_attacks: 'Специальные Атаки',
            fortitude: 'Стойкость',
            reflex: 'Рефлексы',
            will: 'Воля',
            experience: 'Опыт',
            ranged: 'Дальний бой',
            spell_like_abilities: 'Способности, подобные заклинаниям',
            spells_known: 'Известные заклинания',
            spells: 'Заклинания',
            abilities: 'Способности',
            racial_modifiers: 'Расовые модификаторы',
        }
    },
};
